"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import smoothscroll from "smoothscroll-polyfill";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);
import Splide from "@splidejs/splide";

const setupSliders = () => {
  var splideThumb = new Splide(".synergy-map-slide", {
    focus: "center",
    pagination: false,
    updateOnMove: true, //is-activeクラスを移動前に更新するか否か
    type: "loop",
    speed: 1000,
    interval: 6000,
    // autoplay: true,
    pauseOnHover: true,
    mediaQuery: "min",
    perPage: 1,
    gap: "-10%",
    padding: "20%",
    breakpoints: {
      1280: { perPage: 4 },
      768: { padding: "10%", gap: "1%", perPage: 3 },
    },
  });

  var splideModal = new Splide(".synergy-modal-slide", {
    rewind: true,
    pagination: false,
    arrows: true,
    pauseOnHover: true,
    type: "fade",
  });

  splideModal.sync(splideThumb);
  splideModal.mount();
  splideThumb.mount();

  splideThumb.on("move", function () {
    let pins = document.querySelectorAll(".synergy-map-pin");

    pins.forEach((item) => {
      item.classList.remove("is-active");
    });
    var pinNum = splideThumb.index + 1;
    let targetPins = document.querySelectorAll(
      ".synergy-map-pin[data-pin='pin-" + pinNum + "']"
    );

    targetPins.forEach((item) => {
      item.classList.add("is-active");
    });
  });
  new Splide(".synergy-people-slide", {
    type: "loop",
    focus: "center",
    autoplay: true,
    interval: 6000,
    speed: 1000,
    updateOnMove: true,
    pagination: false,
    perPage: 3,
    // padding: "33%",
    gap: "2%",
    breakpoints: {
      768: {
        padding: "10%",
        gap: "10%",
        perPage: 1,
      },
    },
  }).mount();
};
let scrollY;

function scrollLock() {
  if (document.body.classList.contains("is-scroll-locked")) {
    document.body.style.top = "";
    document.body.classList.remove("is-scroll-locked");
    window.scrollTo(0, scrollY);
    return false;
  }

  scrollY = document.documentElement.scrollTop || document.body.scrollTop;

  // メニューを開いたときにスクロール位置が一番上に戻らないように
  document.body.style.top = `-${scrollY}px`;
  document.body.classList.add("is-scroll-locked");
}

let modal = document.querySelector(".modal");
let modalButton = document.querySelectorAll(".synergy-map-slide__item");
let modalSlideWrap = document.querySelector(".synergy-modal-slide");

modalButton.forEach((item) => {
  item.addEventListener(
    "click",
    (e) => {
      let current = e.currentTarget;
      let num = current.dataset.btn;
      current.classList.add("active");
      console.log(num);
      document
        .querySelector(".modal[data-modal='modal" + num + "']")
        .classList.add("active");
      modalSlideWrap.classList.add("active");
      scrollLock();
    },
    false
  );
});

function closeModal() {
  // if (modal.classList.contains("active")) modal.classList.remove("active");
  if (document.querySelector(".synergy-modal-slide.synergy-modal-slide.active"))
    modalSlideWrap.classList.remove("active");
  scrollLock();
}
document.querySelectorAll(".synergy-modal__container").forEach((item) => {
  item.addEventListener(
    "click",
    (e) => {
      closeModal();
    },
    false
  );
});

function scrollAnimation() {
  gsap.set(
    [
      ".synergy-map__mainBuilding--1",
      ".synergy-map__mainBuilding--2",
      ".synergy-map__mainBuilding--3",
      ".synergy-map__mainBuilding--4",
    ],
    {
      y: -200,
    }
  );
  gsap.set(
    [".synergy-map__car", ".synergy-map__person", ".synergy-map__mikoshi"],
    {
      y: 100,
    }
  );
  gsap.set(".synergy-map__subBuilding", { y: -100 });

  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
        duration: 1,
      },
      scrollTrigger: {
        // markers: true,
        trigger: ".synergy-map__wrap", // この要素と交差するとイベントが発火
        start: "top 50%", // ウィンドウのどの位置を発火の基準点にするか
        end: "bottom top", // ウィンドウのどの位置をイベントの終了点にするか
      },
    })
    .add("scene01")
    .to(
      ".synergy-map__mainBuilding--1",
      {
        duration: 0.8,
        opacity: 1,
        y: 0,
      },
      "scene01 +=0.5"
    )
    .to(
      ".synergy-map__mainBuilding--2",
      {
        duration: 0.8,
        opacity: 1,
        y: 0,
      },
      "scene01 +=0.6"
    )
    .to(
      ".synergy-map__mainBuilding--3",
      {
        duration: 0.8,
        opacity: 1,
        y: 0,
      },
      "scene01 +=0.7"
    )
    .to(
      ".synergy-map__subBuilding",
      {
        duration: 0.8,
        opacity: 1,
        y: 0,
      },
      "scene01 +=1.6"
    )
    .to(
      ".synergy-map__car",
      {
        duration: 0.8,
        opacity: 1,
        y: 0,
      },
      "scene01 +=1.8"
    )
    .to(
      ".synergy-map__person",
      {
        duration: 0.8,
        opacity: 1,
        y: 0,
      },
      "scene01 +=2"
    )
    .to(
      ".synergy-map__tent",
      {
        duration: 0.8,
        opacity: 1,
        y: 0,
      },
      "scene01 +=2"
    )
    .to(
      ".synergy-map__mikoshi",
      {
        duration: 0.8,
        opacity: 1,
        y: 0,
      },
      "scene01 +=2"
    )
    .add(function () {
      document.querySelector(".synergy-map__cont").classList.add("is-scrolled");
    }, "scene01 +=2.5");
}

window.addEventListener("DOMContentLoaded", () => {
  setupSliders();
  scrollAnimation();
});

window.addEventListener("resize", function () {
  // new Splide(".synergy-people-slide").refresh();
});
